import './App.css';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import withClearCache from './ClearCache';

import store from './store';

import Home from './pages/Home';

const ClearCacheComponent = withClearCache(MainApp)

function App() {
  return <ClearCacheComponent />
}

function MainApp(props) {
  return (
    <Provider store={store}>
      <Router>
        <Home /> 
      </Router>
    </Provider>
  );
}

export default App;
